import React from 'react';
import { Outlet } from 'react-router-dom';
import MainContent from './MainContent';
import Footer from './Footer';
import DesktopHeader from './header/DesktopHeader';
import MobileHeader from './header/MobileHeader';
import LanguageModal from './header/LanguageModal';

export default function MainLayout() {
  return (
    <>
      <DesktopHeader />
      <MobileHeader />
      <LanguageModal />

      <MainContent>
        <Outlet />
      </MainContent>

      <Footer />
    </>
  );
}
